import { render } from "./contrats_overview.vue?vue&type=template&id=6b3cc862"
import script from "./contrats_overview.vue?vue&type=script&lang=ts"
export * from "./contrats_overview.vue?vue&type=script&lang=ts"
script.render = render

export default script